import React from 'react'
import styles from './SPPlus.module.css'

const SPPlus = () => {
    return (
        <div>SPPlus</div>
    )
}

export default SPPlus